var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 0H1.76889C0.791111 0 0 0.8 0 1.77778L0.00888888 14.2222C0.00888888 15.2 0.8 16 1.77778 16H10.6667L16 10.6667V1.77778C16 0.8 15.2 0 14.2222 0ZM3.55556 4.44444H12.4444V6.22222H3.55556V4.44444ZM8 9.77778H3.55556V8H8V9.77778ZM9.77778 14.6667V9.77778H14.6667L9.77778 14.6667Z",
    fill: "#696E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMenuButton);
export default __webpack_public_path__ + "static/media/ReportMenuButton.4c259234.svg";
export { ForwardRef as ReactComponent };